import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import Swal from 'sweetalert2'
import { queryClient } from "../../..";

export default async function deleteContato(contatoId: number) {
  return await api.delete(`${URLS.CONTATO_API}/${contatoId}`)
  .then((response) => {
    console.log(response);
    queryClient.invalidateQueries();
    Swal.fire({
      title: 'Sucesso',
      text: 'Contato apagado com sucesso!',
      icon: 'success',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#349946',
      allowOutsideClick: false
    })
    return response.status
  })
  .catch((err) => {
    console.log(err);
    if(err.response.status === 500) {
      Swal.fire({
        title: 'Ocorreu um erro',
        text: 'O contato não pode ser excluído pois possuí estoque ou movimentos vinculados',
        icon: 'error',
        position: 'center',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#F27474',
        allowOutsideClick: false
      })
    } else {
      Swal.fire({
        title: 'Ocorreu um erro',
        text: err.response.data.message,
        icon: 'error',
        position: 'center',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#F27474',
        allowOutsideClick: false
      })
    }
  })
}
